import './Program_table.css';
import afternoonSessions from '../../data/program/afternoonSessions';

const SessionsTable = () => {
  return (
    <div className="sessions-program">
      <p className="sessions-note">
        ICSI 2026 — Afternoon Technical Program (LNCS 16874), Beijing. 3 parallel
        rooms (1 onsite, 2 online) · 20 min/talk · 20-min tea break · All times
        in China Standard Time (UTC+8).
      </p>

      {afternoonSessions.map((room) => (
        <section key={room.name} className="sessions-room">
          <h3 className="sessions-room-title">{room.name}</h3>
          <div className="sessions-table-wrap">
            <table className="program-table sessions-table">
              <thead>
                <tr>
                  <th>Time (CST)</th>
                  <th>Paper ID</th>
                  <th>Domain / Session</th>
                  <th>Main Presenter</th>
                  <th>Title</th>
                  <th>Mode</th>
                  <th>Country</th>
                </tr>
              </thead>
              <tbody>
                {room.items.map((item, index) =>
                  item.type === 'break' ? (
                    <tr key={`break-${index}`} className="sessions-break-row">
                      <td colSpan="7">{item.label}</td>
                    </tr>
                  ) : (
                    <tr key={`${item.paperId}-${index}`}>
                      <td>{item.time}</td>
                      <td>{item.paperId}</td>
                      <td className="sessions-domain">{item.domain}</td>
                      <td>{item.presenter}</td>
                      <td className="sessions-title">{item.title}</td>
                      <td>{item.mode}</td>
                      <td>{item.country}</td>
                    </tr>
                  )
                )}
              </tbody>
            </table>
          </div>
        </section>
      ))}
    </div>
  );
};

export default SessionsTable;
